import App from "@bloglovin/inspire-engine/App";
import { PAYMENT_STATUS_SUCCEEDED } from "%/constants/subscription-constants";
import { contextualAppName } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";

// One payment row inside a billing-history feed. The row's pk arrives as the
// scoped `subscriptionBillingHistory` context the feed provides per row, and the
// record itself is already in the engine's registry — the feed materialised it
// while listing the page.
const PAYMENT_ENTITY_TYPE = "SubscriptionBillingHistory";
const DEFAULT_CURRENCY_CODE = "USD";

export const SubscriptionPaymentCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    scopedProvidedContexts: { default: null },
  },
  computed: {
    isEditable() {
      return false;
    },
    paymentEntityId() {
      const fromPage = typeof this.pageEntities === "function"
        ? this.pageEntities()?.subscriptionBillingHistory
        : this.pageEntities?.subscriptionBillingHistory;
      if (fromPage) {
        return fromPage;
      }
      const scoped = typeof this.scopedProvidedContexts === "function" ? this.scopedProvidedContexts() : null;
      const fromScoped = scoped?.subscriptionBillingHistory?.entityPkUrlVars?.id
        ?? scoped?.subscriptionBillingHistory?.pk?.id;
      if (fromScoped) {
        return Number(fromScoped) || fromScoped;
      }
      return 0;
    },
  },
  methods: {
    getExampleEntity() {
      const thirtyDaysInSeconds = 30 * 24 * 60 * 60;
      return {
        id: 0,
        datePaid: Math.floor(Date.now() / 1000) - thirtyDaysInSeconds,
        amountPaid: 9.99,
        status: PAYMENT_STATUS_SUCCEEDED,
        invoiceId: 0,
        subscriptionPlanName: "Pro Monthly",
        billingFrequency: "monthly",
        currencyCode: DEFAULT_CURRENCY_CODE,
      };
    },
    getRealEntity() {
      const id = this.paymentEntityId;
      if (!id) {
        return this.getExampleEntity();
      }
      const entity = App.get(contextualAppName()).getEntity(PAYMENT_ENTITY_TYPE, { id });
      if (entity && (entity.datePaid !== undefined || entity.amountPaid !== undefined)) {
        return entity;
      }
      return this.getExampleEntity();
    },
    formatPaymentDate(timestamp) {
      const seconds = Number(timestamp);
      if (!Number.isFinite(seconds) || seconds <= 0) {
        return "";
      }
      return new Date(seconds * 1000).toLocaleDateString(undefined, {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    formatPaymentAmount(amount) {
      const value = Number(amount);
      if (!Number.isFinite(value)) {
        return "";
      }
      const currency = this.entity?.currencyCode || DEFAULT_CURRENCY_CODE;
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(value);
    },
  },
};
